import { environment } from './../environments/environment.hmr';
import { constantes } from './constantes';
import { DomSanitizer } from '@angular/platform-browser/public_api';
import { AddressComponent } from './utils/address/address.component';
import { Company } from './interfaces/company.interface';
import { ParamsService } from './services/params.service';
import { DataService } from './services/data.service';
import { MapComponent } from './component/map/map.component';
import { NavigationEnd, Router } from '@angular/router';
import { ApplicationRef, Component, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DeviceDetectorService } from 'ngx-device-detector';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
	
	@ViewChild(AddressComponent) address:AddressComponent;
	
	idrub:string;
	idrubSave:string;
	openSidebar:boolean;
	addressVisible:boolean = false;
	isIOS:boolean = true;
	firstRoute:boolean = false;
	isMobile:boolean;
	menuVisible:boolean = true;
	urlWebsite:string = '../';
	
	
	constructor(
		private router:Router,
		private api:ApiService,
		public dt:DataService,
		private paramsService:ParamsService,
		private breakpointObserver:BreakpointObserver,
		private deviceService: DeviceDetectorService,
		
	) {
		
		this.isMobile = this.breakpointObserver.isMatched('(max-width: 768px)');
		this.breakpointObserver.observe('(max-width: 768px)')
		.subscribe(resp => {
			this.isMobile = resp.matches;
		});
		
		this.idrubSave = '';
		
		router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				let idrub: string = this.router.url.substr(1);
				this.idrubSave = this.idrub;
				this.idrub = idrub;
				
				// debugger;
				this.openSidebarFunc(this.idrub != '', this.firstRoute);
				this.firstRoute = true;
			}
			
		});
		
		constantes.os = this.deviceService.os;
		constantes.browser = this.deviceService.browser;
		
		this.paramsService.addListener('closeMenu', this.onCloseMenu.bind(this));
		this.paramsService.addListener('route', this.onClickRoute.bind(this));
		this.paramsService.addListener('openModal', this.onOpenModal.bind(this));
		this.paramsService.addListener('closeModal', this.onCloseModal.bind(this));
		
	}
	
	
	
	
	ngOnInit():void
	{
		this.api.getData()
		.subscribe(
			resp => {
				// debugger;
				/* 
				if(environment.debug){
					resp = {
						companies: [],
						services: [],
						infos: [],
					};
				}
				 */
				// if(environment.debug) resp.infos = [];
				this.dt.initData(resp);
				this.paramsService.dispatch('data_change');
			},
			err => {
				// debugger;
			}
		);
		
	}
	
	
	
	
	
	
	onNavigate(idrub:string, arg:any = null):void
	{
		if(idrub == this.idrub || idrub == ''){
			this.closeRub(idrub);
			this.idrub = '';
			if(idrub == 'adresses') this.idrub = this.idrubSave;
		}
		else{
		// else if(idrub != ''){
			this.openRub(idrub, arg);
			this.idrubSave = this.idrub;
			this.idrub = idrub;
		}
		// debugger;
	}
	
	openRub(idrub:string, arg:any = null):void
	{
		if(idrub == 'adresses'){
			this.addressVisible = true;
			if(this.isMobile) this.openSidebarFunc(false);
			this.address.focus();
		}else{
			let route:any[] = ["/" + idrub];
			this.router.navigate(route, { skipLocationChange: false });
			// debugger;
			this.openSidebarFunc(true);
			this.addressVisible = false;
		}
	}
	
	closeRub(idrub:string):void
	{
		if(idrub == 'adresses'){
			this.addressVisible = false;
		}else{
			this.openSidebarFunc(false);
		}
		
		if(idrub == '' && this.addressVisible) this.addressVisible = false;
	}
	
	
	onCloseMenu():void
	{
		this.openSidebarFunc(false);
	}
	
	onClickRoute(item:any):void
	{
		let address:string = item.address || item.desc;
		this.paramsService.setData('itineraireDest', address);
		
		// debugger;
		if(this.idrub != 'itineraire') this.onNavigate('itineraire');
		
	}
	
	onOpenModal():void
	{
		if(this.isMobile) this.menuVisible = false;
	}
	onCloseModal():void
	{
		this.menuVisible = true;
	}
	
	keydown(event){
		
	}
	
	
	openSidebarFunc(value:boolean, delay:boolean = true):void
	{
		this.openSidebar = value;
		this.paramsService.setData('openSidebar', this.openSidebar);
		
	}
	
}
